// This file is automatically generated. Do not edit manually.

import { PurchaseOrderDeliveryPrintoutPackageDto } from "src/api/generated/erp/purchase/purchaseOrder/dto/purchaseOrderDeliveryPrintoutPackageDto";
import { FrontendDownloadFileHandle } from "src/api/generated/common/frontendDownloadFileHandle";
import { CargoDriver } from "src/api/generated/erp/db/types/tables/cargoDriver";
import { DeliveryPackageType } from "src/api/generated/erp/db/types/tables/deliveryPackageType";
import { PurchaseOrderDeliveryPrintoutPackageService_SavedPrintoutPackages } from "src/api/generated/erp/purchase/purchaseOrder/service/purchaseOrderDeliveryPrintoutPackageService";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace PurchaseOrderDeliveryPrintoutApi {
	export async function getFormInitData(args: {
		purchaseOrderId?: number | null | undefined;
	}): Promise<PurchaseOrderDeliveryPrintoutApi_FormInitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/purchase/purchaseOrder/deliveryPrintout/getFormInitData",
			method: "POST",
			data: {
				purchaseOrderId: args.purchaseOrderId,
			},
		});
		return response as PurchaseOrderDeliveryPrintoutApi_FormInitData;
	}

	export async function printDeliveryPrintouts(args: {
		purchaseOrderId: number;
		cargoDriverId: number | null | undefined;
		packages: Array<PurchaseOrderDeliveryPrintoutPackageDto>;
		includeConsignmentNote?: boolean;
	}): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/purchase/purchaseOrder/deliveryPrintout/printDeliveryPrintouts",
			method: "POST",
			data: {
				purchaseOrderId: args.purchaseOrderId,
				cargoDriverId: args.cargoDriverId,
				packages: args.packages,
				includeConsignmentNote: args.includeConsignmentNote,
			},
		});
		return response as FrontendDownloadFileHandle;
	}

	export async function saveDeliveryPrintouts(args: {
		purchaseOrderId: number;
		cargoDriverId: number | null | undefined;
		packages: Array<PurchaseOrderDeliveryPrintoutPackageDto>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/purchase/purchaseOrder/deliveryPrintout/saveDeliveryPrintouts",
			method: "POST",
			data: {
				purchaseOrderId: args.purchaseOrderId,
				cargoDriverId: args.cargoDriverId,
				packages: args.packages,
			},
		});
		return response as void;
	}

	export async function getFormInitDataForSubcontracting(args: {
		purchaseOrderId?: number | null | undefined;
	}): Promise<PurchaseOrderDeliveryPrintoutApi_FormInitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/purchase/purchaseOrder/deliveryPrintout/getFormInitDataForSubcontracting",
			method: "POST",
			data: {
				purchaseOrderId: args.purchaseOrderId,
			},
		});
		return response as PurchaseOrderDeliveryPrintoutApi_FormInitData;
	}

	export async function printDeliveryPrintoutsForSubcontracting(args: {
		purchaseOrderId: number;
		cargoDriverId: number | null | undefined;
		packages: Array<PurchaseOrderDeliveryPrintoutPackageDto>;
		includeConsignmentNote?: boolean;
	}): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/purchase/purchaseOrder/deliveryPrintout/printDeliveryPrintoutsForSubcontracting",
			method: "POST",
			data: {
				purchaseOrderId: args.purchaseOrderId,
				cargoDriverId: args.cargoDriverId,
				packages: args.packages,
				includeConsignmentNote: args.includeConsignmentNote,
			},
		});
		return response as FrontendDownloadFileHandle;
	}

	export async function saveDeliveryPrintoutsForSubcontracting(args: {
		purchaseOrderId: number;
		cargoDriverId: number | null | undefined;
		packages: Array<PurchaseOrderDeliveryPrintoutPackageDto>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/purchase/purchaseOrder/deliveryPrintout/saveDeliveryPrintoutsForSubcontracting",
			method: "POST",
			data: {
				purchaseOrderId: args.purchaseOrderId,
				cargoDriverId: args.cargoDriverId,
				packages: args.packages,
			},
		});
		return response as void;
	}
}

export interface PurchaseOrderDeliveryPrintoutApi_FormInitData {
	cargoDriverOptions: Array<CargoDriver>;
	packageTypeOptions: Array<DeliveryPackageType>;
	purchaseOrderLineOptions: Array<PurchaseOrderDeliveryPrintoutApi_PurchaseOrderLineOption>;
	savedPrintoutPackages: PurchaseOrderDeliveryPrintoutPackageService_SavedPrintoutPackages;
}

export interface PurchaseOrderDeliveryPrintoutApi_PurchaseOrderLineOption {
	description: string;
	lineNumber: number;
	purchaseOrderLineId: number;
	purchaseQuantity: number;
	purchaseUnit: string;
}
